import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'reservationStatus',
    standalone: false
})
export class ReservationStatusPipe implements PipeTransform {

  transform(statusValue: number): string {
    switch (statusValue) {
      case 1:
        return 'Reserved';
      case 2:
        return 'Approved';
      case 3:
        return 'Expired';
      case 4:
        return 'Cancelled by client';
      case 5:
        return 'Delete';
      default:
        return 'Pending';
    }
  }

}
